"use client";

import { useEffect } from "react";
import Hero from "@/components/hero";
import Clients from "@/components/clients";
import AboutCompany from "@/components/about-company";
import GlobalNetwork from "@/components/global-network";
import Capabilities from "@/components/capabilities";
import Services from "@/components/services";
import BlogInsights from "@/components/blog-insights";
import Footer from "@/components/footer";
import { GlobalOperations } from "@/components/global-operations";
import HomepageSeoContent from "@/components/homepage-seo-content";

export default function HomeClient() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="flex flex-col overflow-x-hidden">
      <Hero />
      <section id="clients" className="bg-background py-8">
        <Clients />
      </section>
      <section id="about" className="py-8">
        <div className="mx-auto max-w-[1400px] px-[3%] lg:px-[5%]">
          <AboutCompany />
        </div>
      </section>
      <GlobalNetwork />
      <section id="capabilities" className="py-8">
        <div className="mx-auto max-w-[1400px] px-[3%] lg:px-[5%]">
          <Capabilities />
        </div>
      </section>
      <section id="services" className="py-8">
        <div className="mx-auto max-w-[1400px] px-[3%] lg:px-[5%]">
          <Services />
        </div>
      </section>
      <section id="global-operations" className="py-8">
        <GlobalOperations />
      </section>
      <section id="blog" className="py-8">
        <div className="mx-auto max-w-[1400px] px-[3%] lg:px-[5%]">
          <BlogInsights />
        </div>
      </section>
      <HomepageSeoContent />
      <Footer />
    </main>
  );
}
